export default "__VITE_ASSET__DRmDl$VP__"